export default __webpack_public_path__ + "static/media/trulli.05d1e0bf.png";